import React, { useEffect, useRef, useState } from "react";

const newsData = [
  { title: "Temple Festival", desc: "Annual festival celebrations start from 25th Dec.", link: "/news/festival" },
  { title: "Special Pooja", desc: "Special Abhishekam on Full Moon Day.", link: "/news/special-pooja" },
  { title: "Annadanam", desc: "Free food service for devotees this weekend.", link: "/news/annadanam" },
  { title: "E-Kanikka Launch", desc: "Online donation facility now available.", link: "/news/ekanikka" },
  { title: "Temple Renovation", desc: "Renovation work begins next month.", link: "/news/renovation" }
];

export default function LatestNews() {
  const trackRef = useRef(null);
  const autoScrollRef = useRef(null);
  const [index, setIndex] = useState(0);

  const cardWidth = 280;

  const moveSlide = (i) => {
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${i * cardWidth}px)`;
    }
  };

  const nextSlide = () => {
    setIndex((prev) => {
      const newIndex = (prev + 1) % newsData.length;
      moveSlide(newIndex);
      return newIndex;
    });
  };

  const prevSlide = () => {
    setIndex((prev) => {
      const newIndex = (prev - 1 + newsData.length) % newsData.length;
      moveSlide(newIndex);
      return newIndex;
    });
  };

  /* START AUTO SCROLL */
  const startAutoScroll = () => {
    autoScrollRef.current = setInterval(nextSlide, 4000);
  };

  /* STOP AUTO SCROLL */
  const stopAutoScroll = () => {
    clearInterval(autoScrollRef.current);
  };

  useEffect(() => {
    startAutoScroll();
    return () => stopAutoScroll();
  }, []);

  return (
    <section className="news-section">
      <h4 style={{ fontSize: "22pt", color: "white" }}>Latest News & Events</h4>

      <div className="news-wrapper">
        <button className="nav-btn prev" onClick={prevSlide}>❮</button>

        <div className="news-track" ref={trackRef}>
          {newsData.map((item, i) => (
            <div
              className="news-card"
              key={i}
              onMouseEnter={stopAutoScroll}
              onMouseLeave={startAutoScroll}
            >
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
              <a href={item.link} className="details-btn">
                Click here for more details →
              </a>
            </div>
          ))}
        </div>

        <button className="nav-btn next" onClick={nextSlide}>❯</button>
      </div>
    </section>
  );
}
